import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withData } from "../common/WithData";
import StudentController from "../api/StudentController";
import AdvisorsView from "../components/AdvisorsView";
import ErrorBoundary from "./ErrorBoundry";

class Advisors extends React.Component
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);

        this.studentController = new StudentController();
    }

    render(): React.ReactNode
    {
        const AdvisorsData = withData(
            AdvisorsView,
            "Current Advisor(s)",
            async () => await this.studentController.getCurrentAdvisors()
        );

        return <Fragment>
            <ErrorBoundary>
                <h2>Advisors</h2>
                <AdvisorsData />
            </ErrorBoundary>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent
});

export default connect(mapStateToProps)(Advisors);